import * as React from 'react';
import { Icon } from 'sos-common/js/components/Icon/icon';
import { autobind } from 'sos-common/js/utils/autobind';

export interface SummaryStepProps {
  headerTitle: string;
  headerBackString: string;
  isDone: boolean;
  stepId: number;
  goToStep: Function;
}

export interface SummaryStepState {}

export default class SummaryStep extends React.Component<SummaryStepProps, SummaryStepState> {
  constructor(props: SummaryStepProps) {
    super(props);
  }

  @autobind
  private changeStep() {
    this.props.goToStep(this.props.stepId);
  }

  public render() {
    const { headerTitle, headerBackString, isDone } = this.props;
    const headerClass = isDone ? 'form-summary__header' : 'form-summary__header form-summary__header--incomplete';
    return (
      <div>
        <div className={headerClass}>
          <h3>{headerTitle}</h3>
          <a href="#" onClick={this.changeStep} className="form-summary__link-back">
            <Icon iconType="baseline-arrow_back-24px" />
            {headerBackString}
          </a>
        </div>
        <ol className="form-summary__list">{this.props.children}</ol>
      </div>
    );
  }
}
